"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInvalidFieldTypeMessage = exports.propertyIsNotNil = exports.getFieldValue = exports.isKeyOfConcentrationLimitFields = exports.isCalcPropertyKey = exports.toLowerIfString = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const getValue_1 = require("../getValue");
const toLowerIfString = (value) => lodash_1.default.isString(value) ? lodash_1.default.toLower(value) : value;
exports.toLowerIfString = toLowerIfString;
const isCalcPropertyKey = (field) => [
    'concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts',
    'eligibilityFields.eligibleExposure',
].includes(field);
exports.isCalcPropertyKey = isCalcPropertyKey;
const isKeyOfConcentrationLimitFields = (test) => {
    const values = [
        'loanProductId',
        'concentrationLimitFields',
        'eligibilityFields',
        'valuationFields',
        'postProcessedFields',
        'requiredIntermediateFields',
        'dynamicIntermediateFields',
        'baseFields',
    ];
    return values.includes(test);
};
exports.isKeyOfConcentrationLimitFields = isKeyOfConcentrationLimitFields;
const getFieldValue = ({ loanTape, field, }) => {
    // we expect the field to be of "a.b" format.
    // or it could be 'loanProductId'
    const [concentrationLimitPropertyGroup, concentrationLimitProperty,] = field.split('.');
    (0, common_1.finleyAssert)((0, exports.isKeyOfConcentrationLimitFields)(concentrationLimitPropertyGroup), `Invalid concentrationLimitPropertyGroup = [${concentrationLimitPropertyGroup}]`);
    return (0, getValue_1.getValue)({
        fields: loanTape,
        concentrationLimitPropertyGroup,
        concentrationLimitProperty,
    });
};
exports.getFieldValue = getFieldValue;
const propertyIsNotNil = (field) => {
    return (loanTape) => !lodash_1.default.isNil((0, exports.getFieldValue)({ loanTape, field }));
};
exports.propertyIsNotNil = propertyIsNotNil;
const getInvalidFieldTypeMessage = ({ field, type, invalidRecord, }) => {
    return `Invalid type value ${type} for field ${String(field)} for external receivable ID ${invalidRecord === null || invalidRecord === void 0 ? void 0 : invalidRecord.externalReceivableId}`;
};
exports.getInvalidFieldTypeMessage = getInvalidFieldTypeMessage;
//# sourceMappingURL=utils.js.map